module.exports = __webpack_public_path__ + "img/red-circle-internet.70c2a1cc.svg";